import { getBackground } from './contentRegistry';

// Resolve a background pick into its contribution. SRD 5.2.1 backgrounds
// grant: 3 ability score points (split player's choice), a feat, 2 skill
// proficiencies, a tool proficiency, equipment, and a flavor description.
//
// ASI handling: pass-through only. The Phase 2 archetype path bakes the
// background ASI into `picks.abilities` along with species bonuses, so this
// function deliberately returns `{}` for ability bonuses unless the caller
// explicitly provides a `chosenAbilityBonuses` map. A future
// `composeAbilityBonuses` mode (see buildPreview.js) will source these from
// user-authored allocations.

export const applyBackground = (backgroundId, chosenAbilityBonuses = null) => {
  const bg = getBackground(backgroundId);
  if (!bg) return null;

  // Background ASI handling:
  //   - If the caller passes `chosenAbilityBonuses`, use them verbatim.
  //   - Otherwise return `{}` (NO bonus). The Phase 2 archetype path bakes
  //     species + background bonuses into `picks.abilities` directly, so
  //     applying a fallback distribution here would double-count.
  //   - A future `kind: 'distribute'` arg could request the round-robin
  //     fallback explicitly, but no caller uses that mode yet.
  const abilityBonuses = chosenAbilityBonuses || {};

  return {
    backgroundId: bg.id,
    backgroundName: bg.name,
    abilityBonuses,
    skillProficiencies: bg.skillProficiencies || [],
    toolProficiencies: bg.toolProficiencies || [],
    languages: bg.languages || [],
    equipment: bg.equipment || [],
    featId: bg.feat?.id || null,
    description: bg.description || '',
  };
};
